export const navList = [
  {
    src: '#59407',
    name: '训练方案',
    path: '/training/programs',
    id: 1,
  },
  {
    src: '#59561',
    name: '训练模块',
    path: '/training/classification',
    id: 8,
  },
  // {
  //   src: '#59407',
  //   name: '列表',
  //   path: '/list',
  //   id: 6,
  // },
  {
    src: '#59260',
    name: '训练自查',
    path: '/',
    id: 5,
  },
  // {
  //   src: '#60835',
  //   name: 'VR',
  //   path: '/',
  //   id: 3,
  // },
  {
    src: '#59257',
    name: '患者管理',
    path: '/',
    id: 4,
  },
  {
    src: '#59155',
    name: '系统设置',
    path: '/settings',
    id: 2,
  }
]

export const iconList = [
  'images/stage/1.png',
  'images/stage/2.png',
  'images/stage/3.png',
  'images/stage/4.png',
  'images/stage/5.png',
  'images/stage/6.png',
  'images/stage/7.png',
  'images/stage/8.png',
  'images/stage/9.png',
  'images/stage/10.png',
  'images/stage/11.png',
  'images/stage/12.png',
]
export const iconHoverList = [
  'images/stage/hover-1.png',
  'images/stage/hover-2.png',
  'images/stage/hover-3.png',
  'images/stage/hover-4.png',
  'images/stage/hover-5.png',
  'images/stage/hover-6.png',
  'images/stage/hover-7.png',
  'images/stage/hover-8.png',
  'images/stage/hover-9.png',
  'images/stage/hover-10.png',
  'images/stage/hover-11.png',
  'images/stage/hover-12.png',
]

export const tabList = [
  '刺激',
  '精细',
  '脱抑制',
  '同时视',
  '融合视',
  '立体视',
  '手眼脑协调',
  '调节',
  '眼球运动',
  '视认知',
]
